import { createLazyRouteComponent } from 'helpers/createLazyRouteComponent'
import { ROUTE } from 'constants/index'

const Request = (store) => ({
  path: ROUTE.REQUEST,
  component: createLazyRouteComponent({
    store,
    reducerKey: 'request',
    loadReducer: () => import('./RequestState'),
    loadComponent: () => import('./RequestContainer'),
  })
})

export default Request
